import React, { ReactNode } from "react";
import { Box, BoxProps, Link, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type Props = {
  firstLine?: ReactNode;
  secondLine?: ReactNode;
} & BoxProps;

export const NoDataStub = ({ firstLine, secondLine, ...rest }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      {...rest}
    >
      {typeof firstLine === "string" || !firstLine ? (
        <Typography variant="body3" mb={1} color="textSecondary">
          {firstLine !== undefined
            ? firstLine
            : t("dashboardPage.dashboard.noDataFirstLine")}
        </Typography>
      ) : (
        firstLine
      )}
      {typeof secondLine === "string" || !secondLine ? (
        <Typography variant="body3" color="textSecondary">
          {secondLine !== undefined ? (
            secondLine
          ) : (
            <Trans
              i18nKey="dashboardPage.dashboard.noDataSecondLine"
              components={{
                linkText: (
                  <Link
                    onClick={() => navigate("/depots/add")}
                    color="textPrimary"
                  />
                ),
              }}
            />
          )}
        </Typography>
      ) : (
        secondLine
      )}
    </Box>
  );
};
